import type { PanelItem } from '@vedalib/editor/lib/elements'
import { generateId } from '@vedalib/editor/lib/utils/id'
import * as R from 'ramda'
import { useCallback } from 'react'
import React from 'react'

import type { IRenderItemProps } from 'components/uiKit/ArrayControl'
import { IconButton } from 'components/uiKit/Button'
import { Tooltip } from 'components/uiKit/Dropdown'
import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'
import { Typography } from 'components/uiKit/Typography'
import { t } from 'services/Translation'

import * as s from './LayoutListItemFormValue.module.scss'

export const LayoutListItemFormValue: React.FC<IRenderItemProps<PanelItem>> = ({
  value: array,
  index,
  drag,
  min,
  max,
  onChange,
}) => {
  const disableClone = Boolean(max && array.length >= max)
  const disableDelete = Boolean(min && array.length <= min)

  const onClone = useCallback(
    () =>
      onChange?.([...array, { ...R.clone(array[index]), value: generateId() }], {
        command: 'clone',
        item: array[index],
      }),
    [onChange, array, index],
  )

  const onDelete = useCallback(
    () =>
      onChange?.(
        array.filter((_item, i) => i !== index),
        { command: 'delete', item: array[index] },
      ),
    [onChange, array, index],
  )

  return (
    <div className={s.root} ref={drag}>
      <span className={s.title}>
        <Icon name='builderDrugAndDrop' size={KitSize.S} />
        <Typography>
          {t('elements.layoutList.form.component')} {index + 1}
        </Typography>
      </span>
      <span className={s.actions}>
        <Tooltip overlay={t('uiKit.tooltip.duplicate')}>
          <IconButton
            disabled={disableClone}
            icon='otherCopy'
            name='clone'
            onClick={onClone}
            size={KitSize.XS}
            styleType='ghost'
          />
        </Tooltip>
        <Tooltip overlay={t('uiKit.tooltip.delete')}>
          <IconButton
            disabled={disableDelete}
            icon='otherTrash'
            name='delete'
            onClick={onDelete}
            size={KitSize.XS}
            styleType='ghost'
          />
        </Tooltip>
      </span>
    </div>
  )
}

export default React.memo(LayoutListItemFormValue) as typeof LayoutListItemFormValue
